import { render, staticRenderFns } from "./transferExcel.vue?vue&type=template&id=edbfdeb2&"
import script from "./transferExcel.vue?vue&type=script&lang=js&"
export * from "./transferExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports